// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====== 首页管理页面布局 ====== */
.homepage-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 130px);
}
.homepage-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.homepage-body {
  display: flex;
  gap: 12px;
  flex: 1;
  min-height: 0;
}
.homepage-config {
  background: #fff;
  border-radius: 8px;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.config-content {
  flex: 1;
  overflow-y: auto;
  padding-top: 12px;
}
.homepage-preview {
  flex: 1;
  background: linear-gradient(180deg, #f5f7fa 0%, #e8ecf2 100%);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.preview-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.preview-hint {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
  text-align: center;
}
/* ====== 配置区组件 ====== */
.size-tip {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  color: #d46b08;
}
.config-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.banner-picker {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
}
.banner-pick-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.banner-pick-item:hover {
  border-color: #1677FF;
  background: #e6f4ff;
}
.banner-pick-title {
  flex: 1;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.banner-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 8px;
}
.banner-list-info {
  flex: 1;
  min-width: 0;
}
.banner-list-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.banner-list-link {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
}
/* ====== 资讯预览宫格 ====== */
.news-preview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.news-preview-item {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 8px;
}
.news-preview-title {
  font-size: 12px;
  color: #333;
  margin: 6px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 130px;
  color: #ccc;
  font-size: 12px;
  border-style: dashed;
}
/* ====== 手机外框 ====== */
.phone-frame {
  width: 320px;
  height: 640px;
  background: #fff;
  border-radius: 32px;
  border: 8px solid #1f1f1f;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.phone-notch {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 18px;
  background: #1f1f1f;
  border-radius: 0 0 12px 12px;
  z-index: 10;
}
.phone-screen {
  flex: 1;
  background: #f5f5f5;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.phone-statusbar {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px 4px;
  font-size: 11px;
  color: #333;
  background: #fff;
  font-weight: 600;
}
.phone-topbar {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.phone-banner {
  position: relative;
  width: 100%;
  flex-shrink: 0;
  aspect-ratio: 750 / 499;
  background: #eee;
  overflow: hidden;
}
.phone-banner img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.phone-banner-dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
}
.phone-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
}
.phone-dot.active {
  background: #fff;
}
.phone-adslot {
  width: calc(100% - 24px);
  margin: 8px 12px;
  border-radius: 6px;
}
.phone-adslot img {
  width: 100%;
  display: block;
}
.phone-empty {
  width: 100%;
  text-align: center;
  font-size: 11px;
  color: #999;
}
.phone-section {
  margin: 8px 12px;
}
.phone-section-title {
  padding: 4px 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.phone-section-more {
  font-size: 11px;
  color: #1677FF;
  font-weight: normal;
}
.phone-activity-card {
  padding: 4px 0;
}
.phone-activity-card img {
  width: 100%;
  height: auto;
  aspect-ratio: 680 / 207;
  border-radius: 4px;
  object-fit: cover;
}
.phone-news-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}
.phone-news-item {
  overflow: hidden;
}
.phone-news-item > img:first-child {
  width: 100%;
  height: 70px;
  object-fit: cover;
  display: block;
}
.phone-news-content-img {
  width: 100%;
  display: block;
}
.phone-news-title {
  font-size: 11px;
  color: #333;
  padding: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.phone-tabbar {
  height: 50px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-shrink: 0;
}
.phone-tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #666;
}
.phone-tab-item img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.phone-tab-icon {
  width: 20px;
  height: 20px;
  background: #e8e8e8;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Homepage/index.less"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AAAF;AAGA;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AADF;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yCAAA;AAFF;AAKA;EACE,OAAA;EACA,gBAAA;EACA,iBAAA;AAHF;AAMA;EACE,OAAA;EACA,6DAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAJF;AAOA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AALF;AAQA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AANF;AACA,wBAAwB;AASxB;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAPF;AAUA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AARF;AAWA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AATF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAVF;AAaA;EACE,qBAAA;EACA,mBAAA;AAXF;AAcA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAbF;AAgBA;EACE,OAAA;EACA,YAAA;AAdF;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfF;AAkBA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAhBF;AACA,yBAAyB;AAmBzB;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AAjBF;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAlBF;AAqBA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnBF;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AApBF;AACA,uBAAuB;AAuBvB;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AArBF;AAwBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;AAtBF;AAyBA;EACE,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAvBF;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxBF;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AAzBF;AA4BA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AA1BF;AA6BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AA3BF;AA8BA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;AA5BF;AA+BA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;AA7BF;AAgCA;EACE,gBAAA;AA9BF;AAiCA;EACE,wBAAA;EACA,gBAAA;EACA,kBAAA;AA/BF;AAkCA;EACE,WAAA;EACA,cAAA;AAhCF;AAmCA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAjCF;AAoCA;EACE,gBAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAnCF;AAsCA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AApCF;AAuCA;EACE,cAAA;AArCF;AAwCA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAtCF;AAyCA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAvCF;AA0CA;EACE,gBAAA;AAxCF;AA2CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAzCF;AA4CA;EACE,WAAA;EACA,cAAA;AA1CF;AA6CA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3CF;AA8CA;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;AA5CF;AA+CA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AA7CF;AAgDA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA9CF;AAiDA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA/CF","sourcesContent":["/* ====== 首页管理页面布局 ====== */\n.homepage-page {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 130px);\n}\n\n.homepage-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #fff;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.homepage-body {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n}\n\n.homepage-config {\n  background: #fff;\n  border-radius: 8px;\n  padding: 0 16px 16px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.config-content {\n  flex: 1;\n  overflow-y: auto;\n  padding-top: 12px;\n}\n\n.homepage-preview {\n  flex: 1;\n  background: linear-gradient(180deg, #f5f7fa 0%, #e8ecf2 100%);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.preview-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.preview-hint {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n}\n\n/* ====== 配置区组件 ====== */\n.size-tip {\n  background: #fff7e6;\n  border: 1px solid #ffd591;\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #d46b08;\n}\n\n.config-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.banner-picker {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.banner-pick-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  background: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.banner-pick-item:hover {\n  border-color: #1677FF;\n  background: #e6f4ff;\n}\n\n.banner-pick-title {\n  flex: 1;\n  font-size: 12px;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.banner-list-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.banner-list-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.banner-list-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.banner-list-link {\n  font-size: 12px;\n  color: #999;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 2px;\n}\n\n/* ====== 资讯预览宫格 ====== */\n.news-preview-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.news-preview-item {\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.news-preview-title {\n  font-size: 12px;\n  color: #333;\n  margin: 6px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.news-preview-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 130px;\n  color: #ccc;\n  font-size: 12px;\n  border-style: dashed;\n}\n\n/* ====== 手机外框 ====== */\n.phone-frame {\n  width: 320px;\n  height: 640px;\n  background: #fff;\n  border-radius: 32px;\n  border: 8px solid #1f1f1f;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.phone-notch {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100px;\n  height: 18px;\n  background: #1f1f1f;\n  border-radius: 0 0 12px 12px;\n  z-index: 10;\n}\n\n.phone-screen {\n  flex: 1;\n  background: #f5f5f5;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.phone-statusbar {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 16px 4px;\n  font-size: 11px;\n  color: #333;\n  background: #fff;\n  font-weight: 600;\n}\n\n.phone-topbar {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.phone-banner {\n  position: relative;\n  width: 100%;\n  flex-shrink: 0;\n  aspect-ratio: 750 / 499;\n  background: #eee;\n  overflow: hidden;\n}\n\n.phone-banner img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.phone-banner-dots {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 4px;\n}\n\n.phone-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.phone-dot.active {\n  background: #fff;\n}\n\n.phone-adslot {\n  width: calc(100% - 24px);\n  margin: 8px 12px;\n  border-radius: 6px;\n}\n\n.phone-adslot img {\n  width: 100%;\n  display: block;\n}\n\n.phone-empty {\n  width: 100%;\n  text-align: center;\n  font-size: 11px;\n  color: #999;\n}\n\n.phone-section {\n  margin: 8px 12px;\n}\n\n.phone-section-title {\n  padding: 4px 0 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.phone-section-more {\n  font-size: 11px;\n  color: #1677FF;\n  font-weight: normal;\n}\n\n.phone-activity-card {\n  padding: 4px 0;\n}\n\n.phone-activity-card img {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 680 / 207;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.phone-news-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n}\n\n.phone-news-item {\n  overflow: hidden;\n}\n\n.phone-news-item > img:first-child {\n  width: 100%;\n  height: 70px;\n  object-fit: cover;\n  display: block;\n}\n\n.phone-news-content-img {\n  width: 100%;\n  display: block;\n}\n\n.phone-news-title {\n  font-size: 11px;\n  color: #333;\n  padding: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.phone-tabbar {\n  height: 50px;\n  background: #fff;\n  border-top: 1px solid #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-shrink: 0;\n}\n\n.phone-tab-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  font-size: 10px;\n  color: #666;\n}\n\n.phone-tab-item img {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.phone-tab-icon {\n  width: 20px;\n  height: 20px;\n  background: #e8e8e8;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
